import { render } from "./PersonForm.vue?vue&type=template&id=4d8b8382&scoped=true"
import script from "./PersonForm.vue?vue&type=script&lang=js"
export * from "./PersonForm.vue?vue&type=script&lang=js"

import "./PersonForm.vue?vue&type=style&index=0&id=4d8b8382&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8b8382"]])

export default __exports__